// extracted by mini-css-extract-plugin
export var button = "books-module--button--c6948";
export var card = "books-module--card--c8c9b";
export var cover = "books-module--cover--ff4c4";
export var coverAuthor = "books-module--coverAuthor--2e4bd";
export var coverLink = "books-module--coverLink--ed5f8";
export var coverTitle = "books-module--coverTitle--d6b4c";
export var disclosure = "books-module--disclosure--04571";
export var grid = "books-module--grid--0f8c6";
export var groupTitle = "books-module--groupTitle--30770";
export var item = "books-module--item--c4df5";
export var itemMeta = "books-module--itemMeta--6b3d4";
export var itemTitle = "books-module--itemTitle--66b90";
export var list = "books-module--list--cabf1";
export var meta = "books-module--meta--a4974";
export var pageBooks = "books-module--pageBooks--83c88";
export var pages = "books-module--pages--1e2c9";
export var title = "books-module--title--eb549";